"use strict";
// tslint:disable
/**
 * Laravel WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthLoginResponseTokenTypeEnum = exports.AuthLoginResponseToJSON = exports.AuthLoginResponseFromJSONTyped = exports.AuthLoginResponseFromJSON = void 0;
function AuthLoginResponseFromJSON(json) {
    return AuthLoginResponseFromJSONTyped(json, false);
}
exports.AuthLoginResponseFromJSON = AuthLoginResponseFromJSON;
function AuthLoginResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'accessToken': json['access_token'],
        'expiresAt': new Date(json['expires_at']),
        'expiresIn': json['expires_in'],
        'memberId': json['member_id'],
        'tokenType': json['token_type'],
    };
}
exports.AuthLoginResponseFromJSONTyped = AuthLoginResponseFromJSONTyped;
function AuthLoginResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'access_token': value.accessToken,
        'expires_at': value.expiresAt.toISOString(),
        'expires_in': value.expiresIn,
        'member_id': value.memberId,
        'token_type': value.tokenType,
    };
}
exports.AuthLoginResponseToJSON = AuthLoginResponseToJSON;
/**
* @export
* @enum {string}
*/
var AuthLoginResponseTokenTypeEnum;
(function (AuthLoginResponseTokenTypeEnum) {
    AuthLoginResponseTokenTypeEnum["Bearer"] = "bearer";
})(AuthLoginResponseTokenTypeEnum = exports.AuthLoginResponseTokenTypeEnum || (exports.AuthLoginResponseTokenTypeEnum = {}));
